import React from "react";

const JumboListContext = React.createContext({});

export default JumboListContext;